import {useConfig} from '@aboutyou/config';
import {GetActiveMissionsResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coins/v1/service.types';
import {
  COLORS,
  FONT_SIZES,
  SPACING,
  Text,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {MissionBadge} from '../../../../backend-services/Coins/MissionBadge/MissionBadge';
import backgroundDark from '../../../Coins/assets/background-dark.png';

export const NewsletterMissionBannerView: React.FC<
  GetActiveMissionsResponse
> = ({missionBanners}) => {
  const {device} = useConfig();

  const banner = missionBanners.find(
    banner => banner.missionBanner?.$case === 'newsletterPageBannerText',
  );

  switch (banner?.missionBanner?.$case) {
    case 'newsletterPageBannerText':
      return (
        <Wrapper>
          <Text color="Text.White" weight="mediumBold">
            {banner.missionBanner.newsletterPageBannerText.title}
          </Text>
          <StyledMissionBadge
            missionType="newsletterMission"
            showCoinsLabel
            small={device === 'mobile'}
          />
        </Wrapper>
      );
    default:
      return null;
  }
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  color: ${COLORS['Text.White']};
  padding: ${SPACING['Y.Md']} ${SPACING['X.Lg']};
  background-image: url(${backgroundDark});
  background-size: cover;
  background-position: bottom;
  background-repeat: no-repeat;

  > span {
    flex: 1;
    font-size: ${FONT_SIZES.px10};
  }

  ${tabletAndUpLinaria(`
    padding: ${SPACING['Y.Md']} ${SPACING['X.Md']};
    padding-left: ${SPACING['X.Xl']};

    > span {
      font-size: ${FONT_SIZES.px12};
    }
  `)}
`;

const StyledMissionBadge = styled(MissionBadge)`
  ${tabletAndUpLinaria(`
    > span {
      font-size: ${FONT_SIZES.px12};
    }
  `)}
`;
